module.exports = __webpack_public_path__ + "img/logo.f016494e.svg";